<template>
	<el-drawer size="800px" title="基础设置" :visible.sync="show" :modal-append-to-body="false" :wrapperClosable="false" :before-close="closeBox">
		<el-container class="weibo-basic">
			<el-main>
				<el-form ref="form" :model="form" :rules="rules" label-width="120px">
					<el-form-item label="微博名称：" prop="weiboName">
						<el-input placeholder="请输入微博名称" v-model="form.weiboName" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="微博ID：" prop="weiboid">
						<el-input placeholder="请输入微博ID" v-model="form.weiboid" clearable disabled>
						</el-input>
					</el-form-item>
					<el-form-item label="授权品牌：" prop="brand">
						 <el-select v-model="form.brand" clearable placeholder="请选择授权品牌" style="width: 100%;" @change="onBrandChange">
						    <el-option
						      v-for="item in brand_options"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
					</el-form-item>
					<el-form-item label="技能组：" prop="skillGroup">
						<el-select v-model="form.skillGroup" clearable placeholder="请选择技能组" style="width: 100%;" :loading="loading_skill">
						   <el-option
						     v-for="item in skillGroup_options"
						     :key="item.skillId"
						     :label="item.skillName"
						     :value="item.skillId">
						   </el-option>
						 </el-select>
					</el-form-item>
					<el-form-item label="消息处理模式：" prop="messageHandleType">
						<el-checkbox-group v-model="form.messageHandleType" class="column-checkbox">
							<el-checkbox label="Test" disabled><span class="text">授权</span></el-checkbox>
							<el-checkbox label="Forward"><span class="text">普通模式</span>所有消息全部转接至OCS+</el-checkbox>
							<el-checkbox label="Keyword"><span class="text">关键词模式</span>触发关键词的聊天转接至OCS+</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					
				</el-form>
			</el-main>
			<el-footer>
				<el-button @click="$emit('close',false)" size="mini">取 消</el-button>
				<el-button type="primary" size="mini" @click="onSubmit" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}
				</el-button>
			</el-footer>
		</el-container>
	</el-drawer>
</template>

<script>
	import {mapGetters} from 'vuex';
	export default {
		computed:{
			 ...mapGetters([
				'subBrandList'
			]),
		},
		model:{
			prop:'show',
			event:'close'
		},
		props:{
			show:{
				default:false,
				type:Boolean
			},
			source:{
				default:''
			}
		},
		watch:{
			show(value){
				if(value){
					this.$nextTick(() => {
						this.$refs['form'].clearValidate();
					})
					this.form.weiboName = this.source.weiboName;
					this.form.weiboid = this.source.weiboId;
					this.form.messageHandleType = this.source.messageHandleType? this.source.messageHandleType.split(',') : ['Test'];
					this.getBrand();
					if(!this.source.forwardUrl) return;
					this.getInfos();
				}else {
					Object.keys(this.form).map(key => {
						this.form[key] = '';
					})
				}
			}
		},
		data(){
			return {
				brand_options:[],
				skillGroup_options:[],
				form:{
					weiboName:'',
					weiboid:'',
					brand:'',
					skillGroup:'',
					messageHandleType: ['Test'],
				},
				rules:{
					brand:[{ required: true, message: '请选择授权品牌', trigger: 'change' }],
					skillGroup:[{ required: true, message: '请选择技能组', trigger: 'change' }],
				},
				loading:false,
				loading_skill:false,
			}
		},
		methods:{
			closeBox(){
				this.$emit('close',false)
			},
			onSubmit(){
				this.$refs.form.validate(valid => {
					if(valid){
						this.loading = true;
						this.$api.apiAcceptAuthForSystem(this.form.weiboid,{
							brand:this.form.brand,
							skillGroup:this.form.skillGroup,
							channel:'weibo'
						}).then(res => {
							this.loading = false;
							if(res.errcode != 0) return;
							this.onUpdate(JSON.parse(res.data));
						}).catch(err => {
							this.loading = false;
						})
					}
				})
			},
			//更新微博设置
			onUpdate(value){
				this.$api.updateWeiboConfigsForSystem({
					weiboid:this.form.weiboid,
					forwardUrl:value.imUrl,
					messageType:this.form.messageHandleType.join(','),
					accessToken: this.source.accessToken,
					appKey: this.source.appKey,
					weiboName:this.form.weiboName
				}).then(res => {
					if(res.errcode != 0) return;
					this.$notify.success('操作成功');
					this.dialogVisible = false;
					this.$emit('getList');
					this.closeBox()
				})
			},
			// 获取回填技能组以及品牌
			async getInfos(){
				await this.$api.apiGetAcceptAuthForSystem(this.source.weiboId).then(res => {
					if(res.errcode != 0) return;
					if(res.data.length == 0) return;
					this.form.brand = res.data[0].childBrand;
					this.getSkillgroupList({
						brand:res.data[0].childBrand,
						skillId:res.data[0].skillId,
					})
				})
			},
			onBrandChange(value){
				if(this.form.brand){
					this.getSkillgroupList({
						brand:this.form.brand,
					})
					return;
				}
				this.skillGroup_options = [];
				this.form.skillGroup = '';
			},
			// 获取可选子品牌列表
			async getBrand(){
				 this.brand_options = await this.subBrandList;
			},
			// 获取可选技能组列表
			async getSkillgroupList(value){
				this.loading_skill = true;
				this.$api.getWechatSystemSkillGroup({brand:value.brand,appid:this.form.weiboid}).then(res => {
					this.skillGroup_options = res.data;
					this.form.skillGroup = value?.skillId || '';
					this.loading_skill = false;
				}).catch(err => {
					this.loading_skill = false;
				}) 
			}
		}
	}
</script>

<style lang="scss" scoped>
	.weibo-basic {
		::v-deep {
			.el-footer {
				display: flex;
				justify-content: flex-end;
				align-items: center;
			}
		}
		.column-checkbox {
			display: flex;
			flex-direction: column;
		
			.text {
				display: inline-block;
				width: 100px;
			}
		}
	}
</style>